import { z } from 'zod';

export const getAgentsSchema = z.object({
  search: z.string().optional(),
  limit: z
    .string()
    .optional()
    .default('10')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export type GetAgentsPayload = z.infer<typeof getAgentsSchema>;
